import { render } from "./ImportAssessmentTasks.vue?vue&type=template&id=2f1254a4&scoped=true"
import script from "./ImportAssessmentTasks.vue?vue&type=script&lang=js"
export * from "./ImportAssessmentTasks.vue?vue&type=script&lang=js"

import "./ImportAssessmentTasks.vue?vue&type=style&index=0&id=2f1254a4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f1254a4"]])

export default __exports__